module.exports = __webpack_public_path__ + "static/bathset-819cb530b5fcbce2258e7b39fd5e5057.jpeg";